export default __webpack_public_path__ + "19f7ad8c00b13fc70eb7af6cb0e2ed3d.svg";